import { RequestPreviewApi } from 'Constants'
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { getCaseType } from 'Utils';

function RequestPreview() {
  const {userDetails, makeApiCallFunc} = useContext(Context);
  const [requestPreview, setRequestPreview] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
      makeApiCallFunc(RequestPreviewApi+userDetails._id, null, 
        ({data}) => 

          processResponse(data?.filter(item => item?.userId !== null))
      ,
      (error) =>
        console.log(error)
)},[]);
const processResponse = (data) => {
  if(data.length > 0)
  {
      // Group by caseNumber
    const groupedResults = data.reduce((acc, item) => {
      if(item?.userId !== null)
      {
      // Find the group by caseNumber, or create a new group if it doesn't exist
      let caseGroup = acc?.find(group => group.casenumber === item?.caseNumber);
      if (!caseGroup) {
          caseGroup = { casenumber: item?.caseNumber, caseId: item?.caseId, caseType: item?.caseType ,users: [] };
          acc?.push(caseGroup);
      }

      // Add user details to the users array
      caseGroup.users.push({
          _id: item?.userId?._id,
          firstName: item?.userId?.firstName,
          lastName: item?.userId?.lastName,
          profilePic: item?.userId?.profilePic,
          company: item?.userId?.company,
          legalType: item?.userId?.legalType
      });

      return acc;
    }
    }, []);
    console.log(groupedResults);
    setRequestPreview(groupedResults);    
  }
  else
  {
  setRequestPreview(data);
  }
}
  return (
    <>
        {
          requestPreview && requestPreview?.length !== 0 &&
          <div className='w-full px-4 pt-6 lg:px-8 lg:pt-8 font-plexsans'>
            <div className='flex justify-between items-baseline mb-3.5'>
              <span className='font-plexmono font-normal text-[10px] leading-none tracking-[.14em] uppercase text-navy/[.45]'>Needs you</span>
              <span className='font-plexmono font-normal text-[10.5px] leading-none text-navy/[.4]'>{requestPreview?.length} open</span>
            </div>
            <div className='rounded-sm overflow-hidden bg-ivory border border-navy/[.14]'>
                {requestPreview?.map((item, index) =>
                <div
                key={item?.casenumber || index}
                onClick={()=>navigate("/client/caseDetails/" + item?.caseId + "?tab=details")} // requests live on the Case Details tab
                className={`flex justify-between items-center gap-4 cursor-pointer py-3.5 px-[18px] ${index === requestPreview.length - 1 ? 'border-b-0' : 'border-b border-navy/[.1]'}`}
                >
                  <div className='flex items-center gap-3 min-w-0'>
                    <span className='flex-none rounded-full w-1.5 h-1.5 bg-brass'></span>
                    <div className='min-w-0'>
                      <div className='font-plexsans font-normal text-[13px] leading-[1.4] text-navy'>
                        Attorney request on <span className='font-plexmono font-normal text-[12px] leading-none text-navy/[.5]'>{item?.casenumber}</span>
                      </div>
                      <div className='truncate font-plexsans font-normal text-[11px] leading-[1.5] text-navy/[.5] mt-0.5'>
                        {item?.users?.map((u) => u.company || (u.firstName + " " + u.lastName)).join(", ")} {item?.users?.length > 1 ? "want" : "wants"} access
                      </div>
                    </div>
                  </div>
                  <span className='flex-none font-plexmono font-medium text-[11.5px] leading-none text-brass'>Review</span>
                </div>
                )}
            </div>
          </div>
        }
    </>
  )
}
export default RequestPreview;
